<div class="relative flex flex-col">
  <!-- Separación visual alumnos / empleados (solo admin ve ambas).
       Posicionado en la misma línea que el botón "Nuevo usuario". -->
  <div *ngIf="isAdmin && !formActive" class="absolute left-0 top-0 z-10 flex gap-2">
    <button (click)="setTab('student')"
      class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200"
      [ngClass]="activeTab === 'student' ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
      Alumnos
    </button>
    <button (click)="setTab('employee')"
      class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200"
      [ngClass]="activeTab === 'employee' ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'">
      Empleados
    </button>
  </div>

  <app-generic-crud [genericCrud]="genericCRUD" (activeFormChange)="formActive = $event"></app-generic-crud>
</div>
